module.exports = __webpack_public_path__ + "static/media/new-narabahasa-logo.ff9f125b.jpeg";